import * as React from 'react'
import './styles.scss'

export const SectionTitle = ({ children }: { children: React.ReactNode }) => (
  <div className="section-component-title">
    <header>{children}</header>
  </div>
)
